module.exports = __webpack_public_path__ + "img/landing-page-bg.81a754d1.png";